import React from 'react';
import RestBanner from '../rest-banner/RestBanner';
import './app.services.scss';

function AppServices(props) {
    return (
      <React.Fragment>
        <RestBanner heading="Our Services" img={'./services_rest.jpg'}/>
        <section id="rest-services">
            <div className="row rest-services">
              {props.ServicesList && props.ServicesList.map((ServicesList,index) => (
                <div className="boxes-list" key={index}>
                  <span id={`services-${index+1}`} className='id-selector'></span>
                  <div className='container'>
                    <div className="inner-img">
                      <img src={`${ServicesList.img.slice(0, -8)}img.jpg`} alt={`${ServicesList.img.slice(0, -8)}img`}/>
                    </div>
                    <div className="inner-content">
                      <h3 className="title">​{ServicesList.heading}</h3>
                      <br/>
                      {ServicesList.desc[0] ? <p className="desc">​{ServicesList.desc[0]}</p> : ''}
                      {ServicesList.desc[1] ? <p className="desc">​{ServicesList.desc[1]}</p> : ''}
                      {ServicesList.desc[2] ? <p className="desc">​{ServicesList.desc[2]}</p> : ''}
                      {ServicesList.desc[3] ? <p className="desc">​{ServicesList.desc[3]}</p> : ''}
                    </div>
                  </div>
                </div>
              ))}
            </div>
        </section>
      </React.Fragment>
    )
}

export default AppServices;
